import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import { Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

function VerComunicado(props) {
	const { comunicado, setQueMostrar } = props

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver comunicado" />
			<Offcanvas.Body id="ver-comunicado">
				<h1>Campos del comunicado</h1>
				{comunicado.borrador ? (<Row>
					<Col sm={12} md={6}>
						<Alert variant="warning">Este comunicado está en modo borrador.</Alert>
					</Col>
				</Row>) : null}
				<Row>
					<Col>
						<label>Título</label>
						<div className="titulo">
							{comunicado.titulo}
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="mb-2">
						<label>Contenido</label>
						<div className="contenido">
							{comunicado.contenido}
						</div>
					</Col>
				</Row>
				<Row className="mb-3">
					<Col>
						<label>Fecha</label>
							<div className="fecha">
								{comunicado.fecha.substr(0, 16)}
							</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<label>Imagen</label>
						<div>
							{comunicado.imagen ? (<img src={process.env.REACT_APP_API_URL + comunicado.imagen.url} alt=""></img>) : '-'}
						</div>
					</Col>
				</Row>
			</Offcanvas.Body >
		<PanelFooter>
			<Button variant="outline-primary" onClick={handleClose} className="me-2">
				Ok
			</Button>
		</PanelFooter>
		</Offcanvas >
	)
}

export default VerComunicado